import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface Props {
  title: string;
  icon: React.ReactElement<SvgIconComponent>;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  onClick?: () => void;
}

const IconButtonWithTooltip: React.FC<Props> = ({ title, icon, color = 'primary', onClick }) => (
  <Tooltip title={title}>
    <Button
      variant="contained"
      color={color}
      onClick={onClick}
      style={{
        marginLeft: '2px',
        width: '30px',
        padding: '3px',
        minWidth: 'unset',
        boxSizing: 'border-box',
      }}
    >
      {icon}
    </Button>
  </Tooltip>
);

export default IconButtonWithTooltip;
